import { prop, pipe, not } from 'ramda';
import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import { connect } from 'react-redux';
import Navbar from './Navbar';

const shouldShowItems = pipe(
  getPOSData,
  prop('limitExceeded'),
  not,
);

const mapStateToProps = state => ({
  showItems: shouldShowItems(state),
});

export default connect(mapStateToProps)(Navbar);
